var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-container"},[_c('div',{ref:"pdfWrapper",staticClass:"pdf-wrapper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }